import React from 'react';
import { commonStyles } from 'utils/designSystem';

const PageContainer = ({ title, icon, children }) => {
  return (
    <div style={commonStyles.pageContainer}>
      <div style={commonStyles.pageHeader}>
        <h1 style={commonStyles.pageTitle}>
          {icon && icon}
          {title}
        </h1>
      </div>
      {children}
    </div>
  );
};

export default PageContainer;